import React, {useEffect} from 'react'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import PrivateRoute from '../../routes/PrivateRoute'
import {useHistory, useLocation} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import Suscripcion from './Suscripcion.page'
import SuscripcionInfo from './SuscripcionInfo.page'
import {bindActionCreators} from 'redux'
import {actionsSuscripcion} from '../../actions/action-creators'
import {suscripcionClear} from '../../actions/suscripcion/suscripcion.actions'
import {KEYS} from '../../constants/keysStorage'

const SuscripcionIndex = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsSuscripcion, dispatch)

  useEffect(() => {
    window.scroll(0, 0)
    actions.suscripcionGetDatosSuscripcion()
    actions.GetValidarSaldo()
    return () => {
      dispatch(suscripcionClear())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    window.scroll(0, 0)
    let rol = localStorage.getItem(KEYS.ROL)
    if (rol !== '2') {
      history.push('/home')
      return
    }
    let url = location.pathname.toLowerCase()
    if (url.includes('/suscripcion/'))
      if (url === '/suscripcion/info' || url === '/suscripcion/factura') return
    history.push('/404')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <BasicLayout>
      <PrivateRoute exact path='/suscripcion/info' component={Suscripcion} />
      <PrivateRoute exact path='/suscripcion/factura' component={SuscripcionInfo} />
    </BasicLayout>
  )
}

export default SuscripcionIndex
